module.exports = __webpack_public_path__ + "img/case4-bg.f097df55.png";